var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDoubleQuotesL = function SvgDoubleQuotesL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.325 16.79C4.398 15.804 3.9 14.7 3.9 12.91c0-3.15 2.211-5.973 5.427-7.369l.804 1.24c-3.002 1.624-3.589 3.73-3.823 5.06.484-.251 1.116-.338 1.736-.28 1.624.15 2.904 1.482 2.904 3.14a3.15 3.15 0 0 1-3.15 3.15c-.966 0-1.89-.442-2.473-1.062m9 0c-.927-.985-1.425-2.09-1.425-3.88 0-3.15 2.211-5.973 5.427-7.369l.804 1.24c-3.002 1.624-3.589 3.73-3.823 5.06.484-.251 1.116-.338 1.736-.28 1.624.15 2.904 1.482 2.904 3.14a3.15 3.15 0 0 1-3.15 3.15c-.966 0-1.89-.442-2.473-1.062"
  })));
};
export default SvgDoubleQuotesL;